/**
 * Product card behaviour: swatch-hover restore, plus the image carousel.
 *
 * The theme's <swatch-item> swaps the card image on mouseenter (and repoints the
 * card link at that variant) but has no mouseleave counterpart, so the last
 * hovered colour sticks. This snapshots each card's starting image, link and
 * selected swatch, and puts them back when the pointer leaves the card.
 */
(function () {
  var CARD_SELECTOR = '.oddit-product-card';
  var SELECTED = 'selected';

  function initCard(card) {
    if (card._odditCardReset) return;

    var img = card.querySelector('[data-product-image] img');
    var link = card.querySelector('[data-product-link]');
    if (!img || !link) return;

    // Snapshot at init: the swatch component only mutates these on hover, which
    // is always later than this runs. Re-taken via _odditCardSnapshot() when
    // something deliberately changes the resting colour (see the main product
    // section's colour sync).
    var snap = {};
    card._odditCardSnapshot = function () {
      snap.srcset = img.getAttribute('srcset');
      snap.src = img.getAttribute('src');
      snap.href = link.getAttribute('href');
      snap.selected = card.querySelector('.swatch__button.' + SELECTED);
    };
    card._odditCardSnapshot();

    card._odditCardReset = function () {
      if (snap.srcset === null) img.removeAttribute('srcset');
      else img.setAttribute('srcset', snap.srcset);
      if (snap.src !== null) img.setAttribute('src', snap.src);
      if (snap.href !== null) link.setAttribute('href', snap.href);

      card.querySelectorAll('.swatch__button.' + SELECTED).forEach(function (el) {
        el.classList.remove(SELECTED);
      });
      if (snap.selected) snap.selected.classList.add(SELECTED);
    };

    card.addEventListener('mouseleave', function () {
      card._odditCardReset();
      // <swatch-item> swaps the first slide's src on hover, so the restored
      // image is only the visible one if the carousel is back on slide 0.
      if (card._odditCardCarousel) card._odditCardCarousel.reset();
    });
  }

  /**
   * Image carousel.
   *
   * The card has always rendered pagination dots, but nothing advanced them and
   * only one image was output — so there was no way to cycle on either pointer
   * or touch (SC1-6, SC1-16). Arrows live outside the card's <a> (a button
   * inside an anchor is invalid) and are revealed on hover by CSS; touch gets a
   * horizontal swipe instead.
   */
  var SWIPE_MIN_PX = 30;

  function initCarousel(card) {
    if (card._odditCardCarousel) return;

    var slides = card.querySelectorAll('.oddit-product-card__img--slide');
    if (slides.length < 2) return;

    var dots = card.querySelectorAll('.oddit-product-card__dot');
    var index = 0;

    function show(next) {
      // Wrap both ways so prev from the first slide lands on the last.
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('oddit-product-card__dot--active', i === index);
      });
    }

    card._odditCardCarousel = { show: show, reset: function () { show(0); } };

    card.querySelectorAll('[data-card-arrow]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        // The arrows overlay the card link; without this a click would follow it.
        event.preventDefault();
        event.stopPropagation();
        show(index + (button.getAttribute('data-card-arrow') === 'next' ? 1 : -1));
      });
    });

    var image = card.querySelector('[data-product-image]');
    if (!image) return;

    var startX = null;
    var startY = null;

    image.addEventListener('touchstart', function (event) {
      var touch = event.changedTouches[0];
      startX = touch.clientX;
      startY = touch.clientY;
    }, { passive: true });

    image.addEventListener('touchend', function (event) {
      if (startX === null) return;
      var touch = event.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      startX = null;
      startY = null;
      // Ignore anything that reads as a vertical scroll rather than a swipe.
      if (Math.abs(dx) < SWIPE_MIN_PX || Math.abs(dx) <= Math.abs(dy)) return;
      show(index + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(CARD_SELECTOR).forEach(function (card) {
      initCard(card);
      initCarousel(card);
    });
  }

  initAll();

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });
})();
